import React, { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

const Page = styled.div`
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: linear-gradient(135deg, #f9fafb, #eef2ff);
    font-family: -apple-system, 'Segoe UI', Roboto, sans-serif;
`

const Card = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 40px 32px;
    max-width: 480px;
    width: 100%;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`

const Logo = styled.div`
    font-size: 22px;
    font-weight: 700;
    color: #2563eb;
    margin-bottom: 24px;
`

const Icon = styled.div`
    font-size: 48px;
    margin-bottom: 12px;
    color: ${({ $danger }) => ($danger ? '#dc2626' : '#111827')};
    line-height: 1;
`

const Title = styled.h1`
    margin: 0 0 12px;
    font-size: 20px;
    color: #111827;
`

const Body = styled.p`
    margin: 0;
    color: #6b7280;
    line-height: 1.6;
    font-size: 14px;

    strong {
        color: #111827;
    }
`

const Note = styled.p`
    margin: 24px 0 0;
    font-size: 12px;
    color: #9ca3af;
`

/**
 * Public unsubscribe confirmation UI (UI Spec 2 §8).
 * Production: backend returns this HTML from
 * POST /ConsolidatedReportUnsubscribe?token={GUID} (no auth).
 * This React route is a FE design preview / template reference.
 */
export const ConsolidatedReportUnsubscribeScreen = () => {
    const [params] = useSearchParams()
    const state = useMemo(() => {
        const raw = (params.get('state') || 'success').toLowerCase()
        return raw === 'invalid' || raw === 'expired' ? 'invalid' : 'success'
    }, [params])
    const scheduleName = params.get('schedule') || 'this digest'

    const isInvalid = state === 'invalid'

    return (
        <Page>
            <Card>
                <Logo>eAuditor</Logo>
                <Icon $danger={isInvalid}>{isInvalid ? '✗' : '✓'}</Icon>
                <Title>
                    {isInvalid
                        ? 'Unsubscribe link invalid'
                        : "You've been unsubscribed"}
                </Title>
                <Body>
                    {isInvalid ? (
                        <>
                            This unsubscribe link is invalid or has already been
                            used. If you&apos;re still receiving digests, please
                            contact your Company Admin directly.
                        </>
                    ) : (
                        <>
                            You will no longer receive the{' '}
                            <strong>{scheduleName}</strong>. If this was a
                            mistake, contact your Company Admin to be added back.
                        </>
                    )}
                </Body>
                <Note>
                    Preview only — live unsubscribe is opened from the digest
                    email footer link (no login).
                </Note>
            </Card>
        </Page>
    )
}
